'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _listing = require('./components/listing');

var _listing2 = _interopRequireDefault(_listing);

var _add = require('./components/add');

var _add2 = _interopRequireDefault(_add);

var _edit = require('./components/edit');

var _edit2 = _interopRequireDefault(_edit);

var _category_listing = require('./components/category_listing');

var _category_listing2 = _interopRequireDefault(_category_listing);

var _category_add = require('./components/category_add');

var _category_add2 = _interopRequireDefault(_category_add);

var _category_edit = require('./components/category_edit');

var _category_edit2 = _interopRequireDefault(_category_edit);

var _subcategory_listing = require('./components/subcategory_listing');

var _subcategory_listing2 = _interopRequireDefault(_subcategory_listing);

var _subcategory_add = require('./components/subcategory_add');

var _subcategory_add2 = _interopRequireDefault(_subcategory_add);

var _subcategory_edit = require('./components/subcategory_edit');

var _subcategory_edit2 = _interopRequireDefault(_subcategory_edit);

var _productPage = require('./components/product-page.config');

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _ngFileUpload = require('ng-file-upload');

var _ngFileUpload2 = _interopRequireDefault(_ngFileUpload);

var _productsPages = require('./services/products.pages.service');

var _productsPages2 = _interopRequireDefault(_productsPages);

var _productsPagesDataprovider = require('./services/products.pages.dataprovider.service');

var _productsPagesDataprovider2 = _interopRequireDefault(_productsPagesDataprovider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('product-page', [_angularUiRouter2.default, _ngFileUpload2.default]).component('productPagesListing', _listing2.default).component('productPageAdd', _add2.default).component('productPageEdit', _edit2.default).component('productPageCategoryList', _category_listing2.default).component('categoryAdd', _category_add2.default).component('categoryEdit', _category_edit2.default).component('subCategoryList', _subcategory_listing2.default).component('subCategoryAdd', _subcategory_add2.default).component('subCategoryEdit', _subcategory_edit2.default).service('ProductPages', _productsPages2.default).service('ProductPagesDataProvider', _productsPagesDataprovider2.default).config(_productPage.ProductPageConfig).name;

// WEBPACK FOOTER //


/** WEBPACK FOOTER **
 ** ./client/app/modules/product-page/index.js
 **/